import { Component } from '@angular/core';

import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { BSModalContext } from 'angular2-modal/plugins/bootstrap';

export class MediaModalContext extends BSModalContext {
    public newAudioFiles: number;
    public newVideoFiles: number;
    public overwritenAudioFiles: number;
    public overwritenVideoFiles: number;
    public wrongFilesCount: number;
    public wrongFilesNames: Array<string>;
}

@Component({
    selector: 'app-modal-content',
    template: `
    <div>Anzahl der hinzugekommenen Audio-Files: {{context.newAudioFiles}}</div>
    <div>Anzahl der hinzugekommenen Video-Files: {{context.newVideoFiles}}</div>
    <div>Anzahl der überschriebenen Audio-Files: {{context.overwritenAudioFiles}}</div>
    <div>Anzahl der überschriebenen Video-Files: {{context.overwritenVideoFiles}}</div>
    <div>Anzahl der ungültigen Dateien: {{context.wrongFilesCount}}</div>
    <div>Die ungültigen Dateien sind die folgenden:</div>
    <div *ngFor="let item of context.wrongFilesNames">{{item}}</div>
    <button (click)="this.dialog.close()">Schließen</button>
    `
})
export class MediaModal implements ModalComponent<MediaModalContext> {
    context: MediaModalContext;

    constructor(public dialog: DialogRef<MediaModalContext>) {
        this.context = dialog.context;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/media.modal.ts